import * as React from 'react';
import { Check, ChevronDown } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from 'src/components/ui/popover';
import { Button } from 'src/components/ui/button';
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from 'src/components/ui/command';
import { cn } from 'src/lib/utils';
import { clsx } from 'clsx';

export function SelectComponentWithSearch({
  inputPlaceholder = 'Search',
  placeholder = 'Select Country...',
  emptyMessage = 'No Items found.',
  items = [],
  setSelected = (_value?: any) => {},
  btnClassName = '',
}) {
  const [open, setOpen] = React.useState(false);
  const [value, setValue] = React.useState('');

  const dialogRoot = document.getElementById('add-payment-method-form');
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          role="combobox"
          aria-expanded={open}
          className={clsx(
            btnClassName,
            'w-full justify-between text-sm font-medium font-jamjuree px-3 py-[7px] h-auto !rounded-sm-5 border-[#B8C1C666] shadow-none aria-expanded:border-green_750 hover:border-ebony',
          )}
        >
          {value ? (
            items.find((country) => country.name === value)?.name
          ) : (
            <span className="opacity-40">{placeholder}</span>
          )}
          <ChevronDown
            width={16}
            className={clsx('transition-transform rotate-0', open && 'rotate-180')}
          />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[250px] p-0 z-50" container={dialogRoot}>
        <Command>
          <CommandInput placeholder={inputPlaceholder} className="h-9" />
          <CommandList>
            <CommandEmpty>{emptyMessage}</CommandEmpty>
            <CommandGroup>
              {items.map((country) => (
                <CommandItem
                  key={country.id}
                  value={country.name}
                  onSelect={(currentValue) => {
                    setValue(currentValue === value ? '' : currentValue);
                    setOpen(false);
                    setSelected(currentValue === value ? {} : country);
                  }}
                >
                  {country.name}
                  <Check
                    className={cn('ml-auto', value === country.name ? 'opacity-100' : 'opacity-0')}
                  />
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
